import React, { useState } from "react";
import FilterIcon from "../../assets/Icons/Pages/Organizational/Management/Staffs/FilterIcon.svg";

const FilterBtn = ({
  btnTitle,
  filterArray = [],
  setFilteredData,
  filteredData,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  // const [filteredData, setFilteredData] = useState([]);
  const handleFilterChange = (value) => {
    setFilteredData((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  return (
    <div className="staffsFilterSearchButtonContainer h-full">
      <button onClick={() => setShowFilter(!showFilter)}>
        <img src={FilterIcon} alt="Filter icon" />
        <span className="filterText">{btnTitle}</span>
      </button>
      {showFilter && (
        <ul className="filterDropdown">
          {filterArray.length > 0 &&
            filterArray.map((role) => (
              <li key={role}>
                <input
                  type="checkbox"
                  value={role}
                  checked={
                    filteredData.length > 0 && filteredData.includes(role)
                  }
                  onChange={() => handleFilterChange(role)}
                />
                <span>{role}</span>
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default FilterBtn;
